import React from 'react';
import dynamic from 'next/dynamic';
import { LargeHeading } from '@/components/Views/Heading';
import { NormalText } from '@/components/Views/Text';
import LargeButton from '@/components/Views/Buttons';
import IconBlock from '@/components/Animations/IconBlock';
import { PARENT_CHECKOUT_PATH, TEACHER_SIGNUP_PATH } from '@/lib/defaults';

const ReactPlayer = dynamic(() => import('react-player'), { ssr: false });

interface Props {
    heading?: string;
    subhead?: string;
    featuredImage?: any;
    videoLink?: string;
}

const VideoFlex2 = ({ heading, subhead, videoLink }: Props) => {
    const desktopFloatingHeartsPositions = [
        { top: '-10%', left: '0%', rotate: -20, scale: 0.5, opacity: 0.2, image: '/icons/float-icon-line-heart.svg' },
        { top: '-14%', left: '30%', rotate: 8, scale: 0.75, opacity: 0.8, image: '/icons/float-icon-line-heart.svg' },
        { top: '-10%', left: '50%', rotate: 30, scale: 1, opacity: 1, image: '/icons/float-icon-line-heart.svg' }
    ];
    const desktopFloatingIconsPositions = [
        { top: '-10%', left: '0%', rotate: -20, scale: 0.5, opacity: 0.2, image: '/icons/float-icon-line-heart.svg' },
        { top: '-14%', left: '30%', rotate: 8, scale: 0.75, opacity: 0.8, image: '/icons/float-icon-line-heart.svg' },
        { top: '-10%', left: '50%', rotate: 30, scale: 1, opacity: 1, image: '/icons/float-icon-line-heart.svg' }
    ];
    const mobileFloatingIconsPositions = [
        { top: '90%', left: '0%', rotate: -10, scale: 0.5, opacity: 0.2, image: '/icons/float-icon-line-heart.svg' },
        { top: '80%', left: '85%', rotate: 0, scale: 0.75, opacity: 0.8, image: '/icons/float-icon-line-heart.svg' },
        { top: '40%', left: '93%', rotate: 30, scale: 1, opacity: 1, image: '/icons/float-icon-line-heart.svg' }
    ];

    const [startPlaying, setStartPlaying] = React.useState(false);

    const buttons = (
        <div className='relative z-20 flex flex-col sm:flex-row gap-4 justify-start'>
            <LargeButton
                className='purple-button h-[44px] w-[190px]'
                text='Sign Up My Child'
                href={PARENT_CHECKOUT_PATH}
            />
            <LargeButton
                href={TEACHER_SIGNUP_PATH}
                className='blue-button h-[44px] w-[190px]'
                text='Sign Up As Educator'
            />
        </div>
    );

    return (
        <div
            className='bg-no-repeat bg-[url("/assets/graphics/ellipse-16.png")]'
            id='learn-more-video-flex-2'
            style={{ backgroundPositionX: '25%', backgroundPositionY: 'center' }}
        >
            <div className='default-py default-px w-full font-Inter pt-10'>
                <div className='my-0 mx-auto flex flex-col lg:flex-row gap-6 lg:gap-10 items-center justify-center default-max-w'>
                    <div className='z-20 w-full relative'>
                        <div className='relative z-20 relative z-20'>
                            <LargeHeading heading={heading} style={{ textAlign: 'left' }} />
                            <NormalText className='text-left w-full mx-auto mt-8 ml-0'>{subhead}</NormalText>
                        </div>

                        <div className='hidden lg:flex flex-col md:flex-row lg:flex-col gap-4'>
                            <div className='relative z-20 flex flex-col sm:flex-row gap-4 justify-start'>
                                <LargeButton
                                    className='dark-button h-[44px] w-[190px]'
                                    text='Watch Video'
                                    onClick={() => setStartPlaying(true)}
                                    rightDelta={true}
                                />
                            </div>

                            {buttons}
                        </div>

                        <IconBlock icons={desktopFloatingIconsPositions} className='hidden lg:block' />
                        <IconBlock icons={mobileFloatingIconsPositions} className='hidden sm:block lg:hidden' />
                    </div>

                    <div className='w-full mt-10 lg:mt-0'>
                        <div style={{ maxWidth: '780px', margin: 'auto' }}>
                            <div className='ghost-inspector-hide relative aspect-video'>
                                <ReactPlayer
                                    style={{
                                        position: 'absolute',
                                        top: 0,
                                        left: 0
                                        // Background: 'green',
                                        // width: `${Math.max(width - 10, 800)}px`,
                                        // height: `${height}px`,
                                        // width: '100%',
                                        // height: '100%',

                                        // marginBottom: '0px',
                                        // marginLeft: 'auto',
                                        // marginRight: 'auto',

                                        // width: '40%'
                                        // background: 'red',
                                        // minHeight: height,
                                        // minHeight: '480px',
                                        // maxHeight: '100%',
                                    }}
                                    playing={startPlaying}
                                    url={videoLink}
                                    // width={width}
                                    // height={height}
                                    width='100%'
                                    height='100%'
                                    controls={true}
                                />
                            </div>
                        </div>
                        <div className='lg:hidden'>
                            <div className='w-full flex justify-center gap-4 mt-4'>
                                {buttons}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <style jsx>{`
                #background-image {
                    background-image: url('/assets/graphics/video-flex-bg.png');
                    background-position: 0% 18%;
                    background-size: 95%;
                    @media (max-width: 1500px) {
                    }
                }
            `}</style>
        </div>
    );
};

export default VideoFlex2;
